import React from 'react';
import { MeatballMenu, ButtonCallToAction, ButtonTertiary } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import * as navigate from 'app/area/shared/navigation';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { DateFormatters } from 'app/infrastructure/data/types';
import { Tag } from 'app/components/tag';

import { DeleteMessageMenu } from '../../common/delete-message-menu';
import { AdministrationMessagesTranslation } from '../../constants';
import { AdministrationMessageItem, AdministrationMessageItemTranslation } from '../types-store';

import styles from './message-form-sticky-header.scss';

export interface MessageFormStickyHeaderProps {
  message: AdministrationMessageItem;
  language: AdministrationMessageItemTranslation;
  canEdit: boolean;
  canDelete: boolean;
  disabled: boolean;
  onSave: () => void;
  onDelete: () => void;
  translation: AdministrationMessagesTranslation;
  formatters: DateFormatters;
}

export const MessageFormStickyHeader: React.FC<MessageFormStickyHeaderProps> = ({
  message, language, canEdit, canDelete, disabled, onSave, onDelete, translation, formatters
}) => {

  const updatingMessage = isDefinedIncludingZero(message && message.id);

  const dateFormatter = (date: string) => formatters.formatDate(parseAsDateUTC(date), {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const onCancel = () => {
    navigate.toAdminMessagesList();
  };

  return <StickyHeader rightSideContent={<>
    <StickyHeaderButtonContainer>
      <ButtonTertiary
        id="message-form-sticky-header-cancel-button"
        onClick={onCancel}>
        {translation.cancel}
      </ButtonTertiary>
      {!!canEdit && <ButtonCallToAction
        id="message-form-sticky-header-save-button"
        onClick={onSave}
        disabled={false}>
        {updatingMessage
          ? translation.update_message
          : translation.add_message
        }
      </ButtonCallToAction>}
    </StickyHeaderButtonContainer>
    {!!canDelete && updatingMessage && <MeatballMenu id="message-form-sticky-header-meatballmenu">
      <li>
        <DeleteMessageMenu
          id={message && message.id}
          onDelete={onDelete}
          disabled={disabled}
          translation={translation} />
      </li>
    </MeatballMenu>}
  </>} >
    {!!message && !!message.messageDate && <div className={styles.messageDate}>{dateFormatter(message.messageDate)}</div>}
    <div className={styles.headerContainer}>
      <h2 className={styles.headerTitle}>
        {updatingMessage
          ? language && language.subject || null
          : translation.new_message}
      </h2>
      {message && message.active
        ? null
        : <div><Tag>{translation.inactive}</Tag></div>}
    </div>
  </StickyHeader>;
};
